import React, { useEffect } from "react";
import styles from "./AutoSubmitPopup.module.css";
import fileSize from "../../assests/popup/fileSize.svg";

const AutoSubmitPopup = ({ handleSubmit, backgroundColor }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div className={styles.mainDiv}>
      <div className={styles.container}>
        <img src={fileSize} alt="" className="w-[56px] h-[56px] mb-[24px]  " />
        <p className="text-regular-medium px-[20px] mb-[16px]">Time's up!</p>
        <p className="text-small text-[#CDCDCD] px-[20px]">
          Your quiz session has ended. Keep practicing and come back soon for
          another round of challenges!"
        </p>
        <div className="seperator my-[20px]" />
        <div className="flex flex-col gap-[16px] w-[100%] cursor-pointer">
          <button
            className={`text-regular-medium ${styles.button}`}
            onClick={handleSubmit}
            style={{
              backgroundColor: backgroundColor,
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutoSubmitPopup;
